<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form @submit.prevent="login">
                <card type="login">
                  <h3 slot="header" class="header text-center">Connexion</h3>

                  <fg-input v-model="form.email" addon-left-icon="nc-icon nc-single-02"
                            placeholder="Adresse mail"></fg-input>

                  <fg-input v-model="form.pwd" addon-left-icon="nc-icon nc-key-25" placeholder="Mot de passe"
                            type="password"></fg-input>

                  <br>

                  <p-button native-type="submit" slot="footer" type="warning" round block class="mb-3">Se connecter</p-button>
                </card>
              </form>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card, Button } from 'src/components/UIComponents';
  import AppNavbar from './Layout/AppNavbar'
  import AppFooter from './Layout/AppFooter'

  export default {
    components: {
      Card,
      AppNavbar,
      AppFooter,
      [Button.name]: Button
    },
    methods: {
      async login() {
        // handle login here
        const params = new URLSearchParams();
        params.append('email', this.form.email);
        params.append('pwd', this.form.pwd);

        const response = await fetch(this.$api_url+'/login', {
          method: 'POST',
          credentials: 'include',
          body: params
          });
        const json = await response.json();
        const self = this;
        if(json.message.hasOwnProperty('id') && json.message.hasOwnProperty('token')) {
            self.log_api("success",'POST /login',params, json)
          localStorage.setItem('token', json.message.token)
          this.notifyVue('top','center', 'success', 'Connecté! 😄', 'fa fa-thumbs-up')
          this.$router.push('/agenda')
        } else {
            self.log_api("error",'POST /login',params, json)
          localStorage.removeItem('token')
          this.notifyVue('top','center', 'danger', 'Problème de connexion! 😱', 'fa fa-thumbs-down')
          this.form.pwd = ""
        } 
      },
      notifyVue (verticalAlign, horizontalAlign, color, message, icon) {
        this.$notify(
          {
            message: message,
            icon: icon,
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: color
          })
      }
    },
    data() {
      return {
        form: {
          email: '',
          pwd: ''
        }
      }
    },
  }
</script>
<style>
</style>
